import { createFileRoute } from '@tanstack/react-router';
import { InvoiceDetail } from '../../../../features/sales-invoicing/InvoiceDetail';

/** Owned by G23. Invoice detail — approve (renders PDF, marks Xero pending), void
 * guard, download PDF, create credit note. */
export const Route = createFileRoute('/_authenticated/sales-invoicing/invoices/$invoiceId')({
  component: InvoiceDetailPage,
});

function InvoiceDetailPage() {
  const { invoiceId } = Route.useParams();
  return <InvoiceDetail invoiceId={invoiceId} />;
}
